var _radialGradient, _linearGradient, _radialGradient2, _linearGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _linearGradient3, _linearGradient4, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKangaroo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 456.247,
    cy: 1605.835,
    gradientTransform: "matrix(.931 0 0 .112 -161.706 186.338)",
    gradientUnits: "userSpaceOnUse",
    r: 250.003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2bcaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2829,
    stopColor: "#eacdc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5032,
    stopColor: "#f1ddd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#fff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d09080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2376,
    stopColor: "#ca8470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4595,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5854,
    stopColor: "#c0755d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#b06045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#aa593d"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 187.54,
    cy: 202.923,
    gradientTransform: "matrix(.703 -.712 .595 .587 -64.922 217.175)",
    gradientUnits: "userSpaceOnUse",
    r: 174.842,
    xlinkHref: "#lg1"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#7a402b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#80432e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#8e4b34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#934d36"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 142.886,
    cy: 267.379,
    gradientTransform: "matrix(1 0 0 1.163 0 -43.58)",
    gradientUnits: "userSpaceOnUse",
    r: 32.939,
    xlinkHref: "#lg2"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 196.918,
    cy: 258.886,
    gradientTransform: "matrix(1 0 0 .646 0 91.679)",
    gradientUnits: "userSpaceOnUse",
    r: 156.347,
    xlinkHref: "#lg2"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 61.029,
    cy: 127.473,
    gradientTransform: "matrix(.577 -.817 .837 .592 -80.947 101.814)",
    gradientUnits: "userSpaceOnUse",
    r: 56.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856,
    stopColor: "#be694f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a402b"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 13.478,
    cy: 171.791,
    gradientTransform: "matrix(1 0 0 .783 0 37.37)",
    gradientUnits: "userSpaceOnUse",
    r: 63.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8a595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3921,
    stopColor: "#cf927e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7444,
    stopColor: "#c67d66"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 29.285,
    cy: 149.782,
    gradientTransform: "matrix(1 0 0 .783 0 32.582)",
    gradientUnits: "userSpaceOnUse",
    r: 45.538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1096,
    stopColor: "#ffdace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    stopColor: "#e2bcaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    stopColor: "#dbac9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d09080"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 366.015,
    cy: 262.881,
    gradientTransform: "matrix(1 0 0 .646 0 93.094)",
    gradientUnits: "userSpaceOnUse",
    r: 142.694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#934d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2194,
    stopColor: "#954e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5012,
    stopColor: "#ab5d44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7674,
    stopColor: "#b9664c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be694f"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 199.534,
    cy: 133.058,
    gradientTransform: "matrix(1 0 0 .781 0 29.175)",
    gradientUnits: "userSpaceOnUse",
    r: 182.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d09080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6695,
    stopColor: "#c27962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8014,
    stopColor: "#b56d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9369,
    stopColor: "#a05942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934d36"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 85.005,
    cy: 244.379,
    gradientTransform: "matrix(1 0 0 .781 0 53.584)",
    gradientUnits: "userSpaceOnUse",
    r: 70.618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9efda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1658,
    stopColor: "#eacdb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#d0937d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    stopColor: "#bf7760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    stopColor: "#ad654e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934d36"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 84.405,
    cy: 210.377,
    gradientTransform: "matrix(.96 -.281 .225 .77 -43.944 72.163)",
    gradientUnits: "userSpaceOnUse",
    r: 55.948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa593d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#be735b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c67d66"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 225.58,
    cy: 202.923,
    gradientTransform: "matrix(.703 -.712 .595 .587 -53.612 244.241)",
    gradientUnits: "userSpaceOnUse",
    r: 174.842,
    xlinkHref: "#lg1"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.702,
    x2: 154.053,
    y1: 300.028,
    y2: 276.617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    stopColor: "#aa593d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6964,
    stopColor: "#9d5239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8349,
    stopColor: "#934d36"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.763,
    x2: 178.763,
    y1: 318.981,
    y2: 262.759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa593d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    stopColor: "#bc7158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4816,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "#c17962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6966,
    stopColor: "#a8614a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#98523b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934d36"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 82.531,
    cy: 192.639,
    gradientTransform: "matrix(.96 -.281 .176 .602 -30.603 99.787)",
    gradientUnits: "userSpaceOnUse",
    r: 60.551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4077,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6789,
    stopColor: "#c47b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    stopColor: "#bf745c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9142,
    stopColor: "#b6694f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa593d"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 83.853,
    cy: 127.473,
    gradientTransform: "matrix(.577 -.817 .837 .592 -71.302 120.449)",
    gradientUnits: "userSpaceOnUse",
    r: 56.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856,
    stopColor: "#d8a595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4624,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    stopColor: "#c57c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#b16348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa593d"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 102.454,
    cy: 146.857,
    gradientTransform: "matrix(-.023 -1 .757 -.018 -6.31 251.873)",
    gradientUnits: "userSpaceOnUse",
    r: 26.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0535,
    stopColor: "#f6d3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    stopColor: "#f5ced0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#f1bec1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7179,
    stopColor: "#eba5a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    stopColor: "#e38288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e28086"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 128.735,
    cy: 226.75,
    gradientTransform: "matrix(.703 -.712 .549 .542 -86.122 195.493)",
    gradientUnits: "userSpaceOnUse",
    r: 65.984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d09080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#ca8470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5895,
    stopColor: "#c0755d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9077,
    stopColor: "#b06045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa593d"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 236.177,
    cy: 219.8,
    gradientTransform: "matrix(.703 -.712 .848 .837 -116.164 203.772)",
    gradientUnits: "userSpaceOnUse",
    r: 118.317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0241,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#e8ae9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#d5937d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3413,
    stopColor: "#ca836c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4119,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#c8816b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    stopColor: "#ce8c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d09080"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 190.916,
    cy: 349.136,
    gradientTransform: "matrix(.703 -.712 .595 .587 -150.875 279.914)",
    gradientUnits: "userSpaceOnUse",
    r: 38.727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d09080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5172,
    stopColor: "#ca8470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c67d66"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 132.576,
    cy: 233.887,
    gradientTransform: "matrix(1 0 0 .771 0 53.547)",
    gradientUnits: "userSpaceOnUse",
    r: 74.004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2134,
    stopColor: "#d89782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#c67d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7161,
    stopColor: "#aa593d"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 7.263,
    cy: 403.858,
    gradientTransform: "matrix(1 0 0 .88 0 -170.889)",
    gradientUnits: "userSpaceOnUse",
    r: 18.878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2171,
    stopColor: "#cd9d94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    stopColor: "#aa7976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4924,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5936,
    stopColor: "#906262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7787,
    stopColor: "#6f4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#664545"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.865 395.196c133.961 0 242.557-13.305 242.557-29.717h-485.114c0 16.412 108.597 29.717 242.557 29.717z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.432 151.813c-28.579.024-49.366 27.138-41.97 54.743l19.28 71.953c5.267 19.656 7.935 39.918 7.935 60.268v5.22h-38.783c-14.54 0-28.533 5.549-39.121 15.515l-6.34 5.967h110.033c6.136 0 10.602-5.82 9.014-11.747l-21.759-81.205h60.102c17.231 0 31.199-13.968 31.199-31.199 0-49.466-40.123-89.556-89.59-89.515z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.829 328.782h.837v-66.028h-17.888v48.977c0 9.417 7.634 17.051 17.051 17.051z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.432 151.813c-28.579.024-49.366 27.138-41.97 54.743l19.28 71.953c5.267 19.656 7.935 39.918 7.935 60.268v5.22h-38.783c-14.54 0-28.533 5.549-39.121 15.515l-6.34 5.967h110.033c6.136 0 10.602-5.82 9.014-11.747l-21.759-81.205h60.102c17.231 0 31.199-13.968 31.199-31.199 0-49.466-40.123-89.556-89.59-89.515z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.152 159.078h-8.951l-4.856-22.246c-1.474-6.752.675-13.785 5.671-18.561 2.048-1.958 5.274-1.958 7.322 0 4.996 4.776 7.145 11.808 5.671 18.561z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.715 176.14-9.741 5.391c-6.772 3.747-10.974 10.875-10.974 18.614v1.696c0 3.175 2.574 5.749 5.75 5.749h24.122l38.932-38.271z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.82 151.813h-24.122c-4.352 0-8.494 1.873-11.367 5.142l-.367.418-10.252 2.588c-3.117.787-5.968 2.374-8.278 4.609-3.353 3.243-8.358 8.124-11.718 11.57h41.267z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.095 215.122 23.307 86.981c5.803 21.656 25.427 36.715 47.847 36.715h43.089c14.725 0 26.661 11.937 26.661 26.661h-61.535c-40.483 0-77.891-21.597-98.132-56.657l-51.701-89.548z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.334 153.715-27.37 41.27v12.606h2.439c6.106 0 16.828 6.19 19.882 11.479l20.487 25.213c9.243 16.008 18.378 28.246 36.863 28.246h195.192c14.976 0 27.116-12.14 27.116-27.116v-.001c0-66.49-53.901-120.39-120.39-120.39-33.114 0-63.106 13.37-84.871 35.006v-.002l-15.065 15.065c-11.29 11.29-30.217 8.798-38.2-5.029l-6.114-10.589c-2.056-3.564-5.856-5.758-9.969-5.758z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.311 246.658-17.622-30.521c-3.053-5.288-8.696-8.546-14.802-8.546h-16.483c6.107 0 11.749 3.258 14.802 8.546l17.622 30.521c9.243 16.008 26.323 25.87 44.808 25.87h16.484c-18.485 0-35.566-9.862-44.809-25.87z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.303 159.47c-2.056-3.562-5.857-5.756-9.969-5.756l-27.37 41.27v12.605h2.439c5.022 0 9.73 2.204 12.943 5.929 8.288-1.68 14.891-8.344 16.268-16.973l6.876-35.02z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.472 151.813c-28.579.024-49.366 27.138-41.97 54.743l19.28 71.953c5.267 19.656 7.935 39.918 7.935 60.268v5.22h-38.783c-14.54 0-28.533 5.549-39.121 15.515l-6.34 5.967h110.033c6.136 0 10.602-5.82 9.014-11.747l-21.759-81.205h60.102c17.231 0 31.199-13.968 31.199-31.199 0-49.466-40.123-89.556-89.59-89.515z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.869 328.782h.837v-66.028h-17.888v48.977c.001 9.417 7.634 17.051 17.051 17.051z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.427 311.731v-48.977h-7.608v48.977c0 9.417 7.634 17.051 17.051 17.051h.837v-1.397c-6.049-2.621-10.28-8.643-10.28-15.654z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.683 158.929c.724-3.686-2.098-7.115-5.854-7.115h-13.009c-4.352 0-8.494 1.873-11.367 5.142l-.367.418-10.252 2.588c-3.117.787-5.968 2.374-8.278 4.609-3.353 3.243-8.358 8.124-11.718 11.57l-9.741 5.391c-6.771 3.747-10.973 10.875-10.973 18.614v1.696c0 3.175 2.574 5.75 5.75 5.75h49.292c10.142 0 18.78-7.369 20.379-17.384z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.976 159.078h-8.951l-4.856-22.246c-1.474-6.752.675-13.785 5.671-18.561 2.048-1.958 5.274-1.958 7.322 0 4.996 4.776 7.145 11.808 5.671 18.561z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.501 153.412c-1.912 0-3.566-1.332-3.974-3.2l-2.856-13.082c-1.079-4.942.494-10.09 4.15-13.585 1.499-1.433 3.86-1.433 5.359 0 3.657 3.495 5.229 8.643 4.15 13.585l-2.856 13.082c-.407 1.868-2.061 3.2-3.973 3.2z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.707 262.754c-17.595 10.158-40.093 4.13-50.252-13.465l-6.243-10.813c-5.079-8.797-2.065-20.047 6.732-25.126 8.797-5.079 20.047-2.065 25.126 6.732z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.472 151.813c-28.579.024-49.366 27.138-41.97 54.743l19.28 71.953c5.267 19.656 7.935 39.918 7.935 60.268v5.22h-38.783c-14.54 0-28.533 5.549-39.121 15.515l-6.34 5.967h110.033c6.136 0 10.602-5.82 9.014-11.747l-21.759-81.205h60.102c17.231 0 31.199-13.968 31.199-31.199 0-49.466-40.123-89.556-89.59-89.515z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.782 278.509c5.267 19.656 7.935 39.918 7.935 60.268v5.22h15.216v-5.22c0-20.35-2.668-40.612-7.935-60.268l-19.28-71.953c-6.85-25.563 10.469-50.703 35.763-54.302-2.963-.294-5.969-.443-9.009-.441-28.579.024-49.366 27.138-41.97 54.743z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.149 343.998h-15.216c-14.54 0-28.533 5.549-39.121 15.515l-6.34 5.967h15.216l6.34-5.967c10.589-9.966 24.581-15.515 39.121-15.515z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.867 249.289-6.243-10.813c-5.079-8.797-2.065-20.047 6.733-25.126 1.127-.651 2.295-1.169 3.485-1.559-4.788-1.559-10.193-1.157-14.897 1.559-8.797 5.079-11.812 16.328-6.733 25.126l6.243 10.813c7.831 13.563 22.994 20.253 37.591 17.953-10.605-1.663-20.394-7.932-26.179-17.953z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.183 188.66c0 2.588-5.097 7.653-8.339 7.653s-8.339-5.065-8.339-7.653 3.733-4.685 8.339-4.685 8.339 2.097 8.339 4.685z",
    fill: "url(#SVGID_23_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKangaroo);
export default __webpack_public_path__ + "static/media/icon-kangaroo.9f6a0af0e3b20f741753de092c28dc62.svg";
export { ForwardRef as ReactComponent };